import { observable } from 'mobx';
import { cast, types } from 'mobx-state-tree';
import { mg } from '../mg/mg';
import { IOcResponse } from '../services/CommSvc';
import { toasterSvc } from '../services/ToasterSvc';
import { DataviewStoreColumn, IDataviewStoreColumn, newDataviewStoreColumn } from '../stores/DataviewStoreColumn';
import { getOmnistore, IOmnistore } from '../stores/Omnistore';

const _columns = [
	'*firstname',
	'*surname',
	'*email',
	// "*emailRep",
].map(newDataviewStoreColumn);

export const RegistrationDialogStore = types.model('RegistrationDialog', {
	state: types.optional(types.enumeration(['NONE', 'RESET', 'MAIN', 'DONE']), 'NONE'),
	columns: types.array(DataviewStoreColumn),
})
	.views(self => ({
		get _omnistore(): IOmnistore {
			return getOmnistore();
		},
	}))
	.volatile(self => observable.object({
		user: {
			email: '',
			emailRep: '',
			firstname: '',
			surname: '',
		},
	}))
	.actions(self => ({
		afterCreate() {
			for (const c of _columns) {
				self.columns.push(c);
				self.user[c.fieldName] = c.emptyValue;
			}
			self.columns = cast(_columns);
		},
		done(r?: IOcResponse) {
			const ok = !!r && !!r.outputList;
			self.state = ok ? 'DONE' : 'NONE';
			if (ok) self._omnistore.authStore.setEmail(self.user.email);
		},
	}))
	.actions(self => ({
		start(email: string) {
			self.state = 'MAIN';
			self.user.email = self.user.emailRep = email;
		},
		cancel() {
			self.state = 'NONE';
		},
		reset(email: string) {
			self.state = 'RESET';
			self.user.email = email;
		},
		resetAction() {
			self._omnistore.communicator.doPost('StartRecovery', { _: self.user.email })
				.then(r => {
					if (r.failure) {
						toasterSvc.failure(r);
					} else {
						toasterSvc.success('recoverPasswordEmailSent');
						this.cancel();
					}
				});
		},
		accept() {
			self._omnistore.communicator.doPost('StartRegistration', self.user)
				.then(toasterSvc.failure)
				.then(self.done, self.done);
		},
	}))
	.views(self => ({
		errorText(column: IDataviewStoreColumn): boolean {
			const value = column.accessors(self.user).getter();
			if (column.isRequired && !value) return true;
			switch (column.name) {
			case 'email': return !('' + value).match(/(.+)@(.+){2,}\.(.+){2,}/);
			case 'emailRep': return value !== self.user.email;
			case 'firstname': return false;
			case 'surname': return false;
			}
			return !!mg.assertTrue(false, 'unknown column', column.name);
		},
	}))
	.views(self => ({
		get isValid(): boolean {
			for (let c of self.columns) {
				if (self.errorText(c)) return false;
			}
			return true;
		},
	}));
